import {
    SUCCESS_GET_FUEL_RATES,
    FAILED_GET_FUEL_RATES,
    SUCCESS_GET_FUEL_RATE_HISTORY,
    FAILED_GET_FUEL_RATE_HISTORY,
} from '../constants/fuelRateConstants';

const defaultState = {
    months: 12,
    providers: [],
    ratesErrorMessage: '',
    history: {
        results: [],
        pagination: {
            page: 1,
            page_size: 50,
            total_count: 0,
            total_pages: 0,
            has_next: false,
            has_previous: false,
        },
    },
    historyErrorMessage: '',
};

export const FuelRateReducer = (state = defaultState, { type, payload, errorMessage }) => {
    switch (type) {
        case SUCCESS_GET_FUEL_RATES:
            return {
                ...state,
                months: payload.months,
                providers: payload.providers || [],
                ratesErrorMessage: '',
            };
        case FAILED_GET_FUEL_RATES:
            return {
                ...state,
                providers: [],
                ratesErrorMessage: errorMessage,
            };
        case SUCCESS_GET_FUEL_RATE_HISTORY:
            return {
                ...state,
                history: {
                    results: payload.results || [],
                    pagination: payload.pagination || defaultState.history.pagination,
                },
                historyErrorMessage: '',
            };
        case FAILED_GET_FUEL_RATE_HISTORY:
            return {
                ...state,
                history: defaultState.history,
                historyErrorMessage: errorMessage,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/state/reducers/fuelRateReducer.js